<hs-mvt-checkbox-control
  [formControl]="basis"
  [sourceAccountId]="sourceAccountId"
  [tranType]="tranType"
  [entryDate]="entryDate"
  [editMode]="editMode"
  [transaction]="transaction"
  [mvtDataMap]="mvtDataMap"
  [destinationAccountId]="destinationAccountId"
  (basisUpdate)="onBasisUpdate($event)"
  (inOutMvtBases)="setInOutMvtBases($event)"
  (errorDetails)="setErrorDetails($event)"
  (errorHeader)="setErrorHeader($event)"
></hs-mvt-checkbox-control>

<nf-table-layout
  class="transfer-table"
  hideTitle
  [isSectionTitle]="false"
  [gridOptions]="gridOptions"
  [data]="rowData"
  hideSearch
  [autoResizeGrid]="false"
  hideClearAll
>
</nf-table-layout>
